module.exports = __webpack_public_path__ + "static/img/avatar-128-128.bac6d90.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/avatar-128-128.png
// module id = 884
// module chunks = 1